import React from 'react';

import {useTour} from '@reactour/tour';
import {Separator} from 'src/components/separator';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {suppressAiTour} from 'src/openapi/apis/AiTourControllerApi';
import {updateChangeRequestSuccess} from 'src/openapi/apis/ChangeRequestControllerApi';
import {TourType} from 'src/openapi/models/TourType';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    mode: EventCreationMode,
};

export const AiFeedbackTour = ({mode}: Props) => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const {setIsOpen} = useTour();

    const onClick = async () => {
        const tourType = mode.toUpperCase() as TourType;
        const response = await dispatch(suppressAiTour({tourType}));

        if (response.payload?.success) {
            setIsOpen(false);

            onCreateNote({
                id: updateChangeRequestSuccess.type,
                status: Status.SUCCESS,
                message: 'Saved',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: 2000,
            });
        }

        if (response.payload?.error) {
            onCreateNote({
                id: 'suppressAiTourError',
                status: Status.ERROR,
                message: response.payload.data?.message,
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: 10000,
            });
        }
    };

    return (
        <Group direction="v" className="pt-s">
            <Group direction="v">
                <Item><strong>AI Feedback</strong></Item>
                <Separator/>
                <Group direction="v" gap="s">
                    <Group alignItems="center">
                        <Item><strong>Hover</strong></Item>
                        <BasicIconButton iconProps={{type: Icons.CHAT, size: Sizes.Size_16}}/>
                        <Item><strong>to view detailed AI feedback.</strong></Item>
                    </Group>
                    <Item>The feedback includes a summary, risks and recommendations for each field.</Item>
                </Group>
                <Item>
                    <strong>Note:</strong> AI Assist provides recommendations only.
                    The Usage Data team does final review and approval.
                </Item>
                <Group justify="end">
                    <FlatButton onClick={onClick}>Don't show again</FlatButton>
                </Group>
            </Group>
        </Group>
    );
};
